export class ToastMan {
    static container;
    static init() {
        let inner = document.querySelector('#toast-container > div');
        if (!inner) {
            // Self-mount when the page didn't include the toast fragment, so show() never throws
            // (e.g. an error toast from the login page's Google button). Mirrors fragments/toast.html.
            const container = document.createElement('div');
            container.id = 'toast-container';
            container.setAttribute('aria-live', 'assertive');
            container.className = 'pointer-events-none fixed inset-0 z-[60] flex items-end px-4 py-6 sm:items-end sm:p-6';
            inner = document.createElement('div');
            inner.className = 'flex w-full flex-col items-center space-y-4 sm:items-end';
            container.appendChild(inner);
            document.body.appendChild(container);
        }
        this.container = inner;
    }
    static show({ message, description, type = 'success', duration = 3000 }) {
        if (!this.container)
            this.init();
        const toast = document.createElement('div');
        toast.className = `pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5 transform transition ease-out duration-300 opacity-0 translate-y-2 sm:translate-y-0 sm:translate-x-2`;
        // Set icon based on type
        const icon = {
            success: 'text-green-400',
            error: 'text-red-400',
            info: 'text-blue-400',
            warning: 'text-yellow-400',
        }[type];
        toast.innerHTML = `
      <div class="p-4">
        <div class="flex items-start">
          <div class="shrink-0">
            <svg class="size-6 ${icon}" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-medium text-gray-900">${message}</p>
            ${description ? `<p class="mt-1 text-sm text-gray-500">${description}</p>` : ''}
          </div>
          <div class="ml-4 flex shrink-0">
            <button class="close-toast inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500">
              <span class="sr-only">Close</span>
              <svg class="size-5" viewBox="0 0 20 20" fill="currentColor">
                <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    `;
        this.container.appendChild(toast);
        requestAnimationFrame(() => {
            toast.classList.remove('opacity-0', 'translate-y-2', 'sm:translate-x-2');
            toast.classList.add('opacity-100', 'translate-y-0', 'sm:translate-x-0');
        });
        // Close button logic
        toast.querySelector('.close-toast')?.addEventListener('click', () => {
            this.hide(toast);
        });
        // Auto-dismiss after duration
        setTimeout(() => this.hide(toast), duration);
    }
    static hide(toast) {
        toast.classList.remove('opacity-100', 'translate-y-0', 'sm:translate-x-0');
        toast.classList.add('opacity-0');
        setTimeout(() => {
            toast.remove();
        }, 100); // match leave transition
    }
}
